import { gql } from '@apollo/client'

export const contactDataMutation = gql`
  mutation contactData($email: String!, $addresses: [InputAddress]) {
    contactData(email: $email, addresses: $addresses) {
      success
    }
  }
`
